<template>
  <div class="students text-dark">
    <button @click="isShowModal = true"> {{ isEditSubject }} {{ studentCalendarIds.length }} {{
        $t('vue2.students.of')
      }} {{
        klassStudents.length
      }} {{ $t('vue2.students.students') }}
    </button>
    <DModal :show-close="false" v-if="isShowModal">
      <div class="d-modal d-modal__students" slot="insertComponent" style="width: 400px">
        <div class="d-modal__header">
          <h2>{{ studentsSelected.length }} {{ $t('vue2.students.of') }} {{ klassStudents.length }}
            {{ $t('vue2.students.students_in') }} 1.a</h2>
          <div class="d-modal__close icon__bg-circle" @click="closeStudentModal">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="d-modal__content">
          <div class="d-modal__content__add-student">
            <transition-group></transition-group>
            <p class="text-link" @click="isAddStudentFromAnotherGroup = true" v-if="!isAddStudentFromAnotherGroup">
              {{ $t('vue2.students.add_student') }}</p>
            <DSelect :items="studentsFromOtherGroups"
                     class="marg-1-bottom"
                     v-else
                     @add="addStudentToSubject($event)"
                     :itemsSelected="[]"
                     :placeholder="$t('vue2.students.add_student')"
                     :showSelectedUsers="false">
            </DSelect>
          </div>
          <div class="students__student__header border-1-bottom border-1-top">
            <p @click="selectAll">
              <span v-if="studentsSelected.length === klassStudents.length">{{
                  $t('vue2.students.unselect_all')
                }}</span>
              <span v-else>{{ $t('vue2.students.select_all') }}</span></p>
          </div>
          <div class="border-1-bottom">
            <ul class="students students__list">
              <li class="students__student" v-for="student in studentsSorted"
                  @click="toggleInStudentsSelected(student.id)">
                <div class="students__student__name">
                  <div class="d-checkbox" :class="{'d-checkbox--active': isInStudentsSelected(student.id)}"></div>
                  <div>
                    {{ student.name }}
                  </div>
                </div>
                <div class="student__grade">
                  <span v-for="(klass, key) in getStudentKlasses(student)"><span v-if="key > 0">, </span> {{
                      klass.name
                    }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="d-modal__buttons pad-1">
          <button class="bttn bttn-simple marg-1-right" @click="closeStudentModal">{{
              $t('vue2.common.cancel')
            }}
          </button>
          <button class="bttn submit-button" @click="submit">{{ $t('vue2.common.save') }}</button>
        </div>
      </div>
    </DModal>
  </div>
</template>
<script>
import DModal from '../common/DModal'
import DSelect from '../DSelect/DSelect'

export default {
  components: {DSelect, DModal},
  props: {
    calendarId: {
      default: '141457'
    },
    studentCalendarIds: {
      type: Array,
      default: () => []
    },
    isNotEditSubject: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowModal: false,
      studentsForSubject: [],
      studentsSelected: [],
      isAddStudentFromAnotherGroup: false
    }
  },
  computed: {
    studentsInArr () {
      return this.studentsForSubject.filter(id => this.allCalendarsInHash[id]).map(id => this.allCalendarsInHash[id])
    },
    studentsSorted () {
      return this.studentsInArr.sort((a, b) => a.name.localeCompare(b.name))
    },
    studentsFromOtherGroups () {
      return this.students.filter(student => {
        // Is student already in klass
        const idx = student.klasses.indexOf(this.calendarId)
        // Is student selected on subject
        return idx < 0 && this.studentsForSubject.indexOf(student.id) < 0
      })
    },
    students () {
      return this.$store.getters.studentCalendars
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    klassStudents () {
      let students = this.allCalendarsInHash[this.calendarId] && this.allCalendarsInHash[this.calendarId].students ? this.allCalendarsInHash[this.calendarId].students : []
      return students.filter(studentId => this.allCalendarsInHash[studentId] && !this.allCalendarsInHash[studentId].archived_at)
    },
    getCalendarName () {
      return this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].name : this.$t('vue2.students.the_group')
    }
  },
  methods: {
    getStudentKlasses (student) {
      return student.klasses.filter(klassCalId => this.allCalendarsInHash[klassCalId]).map(klassCalId => this.allCalendarsInHash[klassCalId])
    },
    setStudentsForSubject () {
      this.klassStudents.forEach(studentId => {
        this.studentsForSubject.push(studentId)
        if (this.isNotEditSubject) {
          this.studentsSelected.push(studentId)
        }
      })
      if (this.isNotEditSubject) {
        this.$emit('changed', this.studentsSelected)
      }
    },
    selectAll () {
      if (this.studentsSelected.length === this.studentsSorted.length) {
        this.studentsSelected = []
      } else {
        this.studentsSorted.forEach(student => {
          let idx = this.studentsSelected.indexOf(student.id)
          if (idx < 0) {
            this.studentsSelected.push(student.id)
          }
        })
      }
    },
    addStudentToSubject (item) {
      this.studentsForSubject.push(item.id)
      this.studentsSelected.push(item.id)
    },
    isInStudentsSelected (itemId) {
      return this.studentsSelected.indexOf(itemId) > -1
    },
    toggleInStudentsSelected (itemId) {
      let idx = this.studentsSelected.indexOf(itemId)
      if (idx < 0) {
        this.studentsSelected.push(itemId)
      } else {
        this.studentsSelected.splice(idx, 1)
      }
    },
    closeStudentModal () {
      this.isAddStudentFromAnotherGroup = false
      this.isShowModal = false
    },
    submit () {
      this.$emit('changed', this.studentsSelected)
      this.closeStudentModal()
    }
  },
  beforeMount () {
    this.setStudentsForSubject()
    // select all students from prop
    this.studentCalendarIds.forEach(studentCalId => {
      // Add student to klassList if he/she is NOT part of the klass of students
      if (this.klassStudents.indexOf(studentCalId) < 0) {
        this.studentsForSubject.push(studentCalId)
        this.studentsSelected.push(studentCalId)
      } else {
        this.studentsSelected.push(studentCalId)
      }
    })
  }
}
</script>


<style scoped>
@import "../../assets/css/variables.css";

.students__student {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .25rem 0.5rem 0.25rem 1rem;
  border-radius: .5rem;
  transition: background-color .25s;
  cursor: pointer;
}

.students__student:hover {
  background: #ecedf2;
}

.students__student .icon__bg-circle {
  opacity: 0;
  transition: opacity 0.25s;
}

.students__student:hover .icon__bg-circle {
  opacity: 1;
}

.students__list {
  max-height: 50vh;
  overflow-y: auto;
}

.d-modal__students .d-modal__content {
  padding: 0;
}

.d-modal__students .d-modal__buttons {
  margin: 0;
}

.d-modal__content__add-student {
  padding: 0 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.students__student__name {
  display: flex;
  align-items: center;
}

.students__student__name .d-checkbox {
  margin-left: 0;
  margin-right: 0.5rem;
  background: #ffffff;
}

.students__student__name .d-checkbox.d-checkbox--active {
  background: var(--blue);
}


.students__student__header {
  display: flex;
  align-items: center;
  padding: 0.25rem 1rem;
  background: var(--bg-grey);
}

.students__student__header p {
  font-size: 0.85rem;
  color: var(--blue);
  cursor: pointer;
}

.student__grade {
  padding-right: 0.5rem;
}

.text-link {
  color: var(--blue);
  cursor: pointer;
}

.text-link:hover {
  color: var(--dark-blue);
}
</style>



// WEBPACK FOOTER //
// StudentsOnSubject.vue?386bdf60